import React from 'react';
import PropTypes from 'prop-types';

import {
	MButtonSwitch,
	MInputField,
	MSmartField,
	MLargeInputField,
} from '../../molecules';

export default function OAccessoiresBasicInfo({
	type,
	title,
	slug,
	category,
	categoryItems,
	description,
	onTypeChange,
	onTitleChange,
	onSlugChange,
	onCategoryChange,
	onDescriptionChange,
}) {
	return (
		<section className="o-product-detail-info">
			<MButtonSwitch
				label="Type"
				items={['Huis houdelijk', 'Industrieel', 'Huren']}
				index={type}
				onChange={onTypeChange}
			/>
			<MInputField
				id="pbiTitle"
				label="Title"
				value={title}
				required
				onChange={onTitleChange}
			/>
			<MInputField
				id="pbiSlug"
				label="Slug"
				value={slug}
				required
				onChange={onSlugChange}
			/>
			<MSmartField
				id="pbiCategory"
				label="Categorie"
				value={category}
				items={categoryItems}
				required
				onChange={onCategoryChange}
			/>
			<MLargeInputField
				id="pbiDescription"
				label="Beschrijving"
				value={description}
				required
				onChange={onDescriptionChange}
			/>
		</section>
	);
}

OAccessoiresBasicInfo.propTypes = {
	title: PropTypes.string,
	type: PropTypes.string,
	slug: PropTypes.string,
	category: PropTypes.string,
	categoryItems: PropTypes.array,
	description: PropTypes.string,
	onTypeChange: PropTypes.func,
	onTitleChange: PropTypes.func,
	onSlugChange: PropTypes.func,
	onCategoryChange: PropTypes.func,
	onDescriptionChange: PropTypes.func,
};

OAccessoiresBasicInfo.defaultProps = {
	title: '',
	type: '',
	slug: '',
	category: '',
	categoryItems: '',
	description: '',
	onTypeChange: undefined,
	onTitleChange: undefined,
	onSlugChange: undefined,
	onCategoryChange: undefined,
	onDescriptionChange: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/cms/_organisme.accessoires-basic-info.js